import { Component, input } from '@angular/core';

@Component({
  selector: 'app-assessment-info',
  template: `<p>assessment-info works!</p>`,
  standalone: true,
})
export class AssessmentInfoComponent<T> {
  data = input.required<T>();
}
